import React, { useState } from 'react'

const CustomInput = ({
  placeholderValue,
  labelValue,
  onChange,
  value,
  disable,
  inputtype = 'text',
  formatMobileNumber = false,
  formatAadharNumber = false,
  formatVerifyOtp = false,
  formatCarNumber = false,
}) => {
  const [formattedValue, setFormattedValue] = useState(value || '')

  const handleAadhaarChange = (e) => {
    let newValue = e.target.value.replace(/\D/g, '') // Remove any non-digit characters

    if (newValue.length <= 12) {
      // Format the Aadhaar number with dashes
      newValue = newValue.replace(/(\d{4})(\d{4})(\d{4})/, '$1-$2-$3')
    }

    setFormattedValue(newValue)
    handleChange(e) // Pass the event to the parent handler, if needed
  }
  const handleChange = (event) => {
    let inputValue = event.target.value
    if (formatMobileNumber) {
      inputValue = inputValue.replace(/[^0-9+]/g, '')
      if (inputValue.startsWith('+') && inputValue.length > 1) {
        inputValue = '+' + inputValue.slice(1).replace(/[^0-9]/g, '')
      }
    }
    if (formatCarNumber) {
      const carNumberRegex = /^[A-Za-z]{0,2}[0-9]{0,2}[A-Za-z]{0,2}[0-9]{0,4}$/
      if (carNumberRegex.test(inputValue)) {
        inputValue = inputValue.replace(/[^A-Za-z0-9]/g, '').toUpperCase()
      } else {
        return
      }
    }
    onChange(inputValue)
  }

  return (
    <div className="flex gap-1 w-full flex-col text-start max-w-96">
      <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
        {labelValue}
      </label>
      <input
        type={inputtype}
        value={formatAadharNumber ? formattedValue : value}
        disabled={disable}
        className="border-b border-gray-300 text-gray-900 text-xs md:text-base focus:border-b focus:border-blue-500 block w-full pb-1 pt-1  outline-none"
        placeholder={placeholderValue}
        onChange={formatAadharNumber ? handleAadhaarChange : handleChange}
        maxLength={
          formatMobileNumber
            ? 10
            : formatAadharNumber
            ? 12
            : formatVerifyOtp
            ? 6
            : formatCarNumber
            ? 10
            : 100
        }
      />
    </div>
  )
}

export default CustomInput
